const numberFormat = (value: any) => {

	value = parseFloat(value)

	if (isNaN(value)) {
		return '';
	}

	if (typeof (value) !== 'number') {
		return typeof (value);
	}
	return parseFloat(value.toString()).toLocaleString('en-US', {
		style: 'decimal',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	});
}

const formatReportQuantity = (value: any) => {
	const num = parseFloat(value);

	if (isNaN(num) || num === 0) {
		return '';
	}

	return String(parseFloat(num.toFixed(2)));
}

const formatDecimalQuantity = (value: any, maxDecimals = 5) => {
	if (value === null || value === undefined || value === '') {
		return '';
	}

	const num = Number(value);

	if (isNaN(num)) {
		return '';
	}

	return String(parseFloat(num.toFixed(maxDecimals)));
}

const formatWholeNumber = (value: any) => {
	const num = parseFloat(value);

	if (isNaN(num)) {
		return '';
	}

	return num.toLocaleString('en-US', {
		maximumFractionDigits: 0,
	});
}

const capitalize = (str: string) => {
	if (!str || typeof str !== 'string') return ''; // Guard clause for undefined or non-string inputs
	return str.charAt(0).toUpperCase() + str.slice(1);
}

const unitNameByProject = (project: any) => {
	let unit = 'lt';
	if (project === '1') {
		unit = 'lt';
	} else if (project === '2') {
		unit = 'mm';
	}
	return unit;
}

const getThisFiscalYearRange = (date = new Date()) => {
	const year = date.getFullYear();
	const month = date.getMonth() + 1;
	const fiscalYearStart = month < 7 ? year - 1 : year;

	return {
		fromDate: `${fiscalYearStart}-07-01`,
		toDate: `${fiscalYearStart + 1}-06-30`,
	};
};

const getLastFiscalYearRange = (date = new Date()) => {
	const { fromDate } = getThisFiscalYearRange(date);
	const fiscalYearStart = parseInt(fromDate.slice(0, 4), 10);

	return {
		fromDate: `${fiscalYearStart - 1}-07-01`,
		toDate: `${fiscalYearStart}-06-30`,
	};
};


export { numberFormat, formatReportQuantity, formatDecimalQuantity, formatWholeNumber, capitalize, unitNameByProject, getThisFiscalYearRange, getLastFiscalYearRange };

